import { render, staticRenderFns } from "./DeviceTwin.vue?vue&type=template&id=6afb4c25&"
import script from "./DeviceTwin.vue?vue&type=script&lang=js&"
export * from "./DeviceTwin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports